// Module
var code = "<div id=\"deterministic-error-container\" class=\"flex-center wrapper\">\n  <div class=\"flex-center icon-wrapper\">\n    <img id=\"deterministic-error-img\" />\n    <div class=\"text-wrapper\">\n      <div id=\"deterministic-error-message\"></div>\n    </div>\n  </div>\n</div>\n";
// Exports
export default code;